// extracted by mini-css-extract-plugin
export default {"projectLogoPlaceHolder":"project-logo-placeholder_projectLogoPlaceHolder__3yXKP"};